// extracted by mini-css-extract-plugin
module.exports = {"content":"ChangePasswordPage_content__cEXxF"};